/**
 * CTA band. design.md 5.16.
 *
 * The closing section of every page except Impressum and AGB. Its content is
 * the homepage's own contact block, so it is read from the homepage's block
 * data through `contactBlockOf` and never retyped here. That costs one small
 * content chunk, which is the price of having exactly one origin for the
 * strings; the band renders nothing until that chunk has arrived, and the page
 * around it is never blocked, because the read sits behind its own Suspense.
 */
import { Suspense, use } from 'react';
import type { ButtonBlockData, HeadingBlockData } from '@/lib/content';
import { blocksOf, contactBlockOf, headingInner } from '@/lib/blueprint';
import ContactActions from './ContactActions';

function Band() {
  const blocks = use(blocksOf('/'));
  const contact = contactBlockOf(blocks);
  if (!contact.buttons.length) return null;

  return (
    <section id="kontakt-band" style={{ scrollMarginTop: '120px' }} className="hp-cta-band on-dark" aria-labelledby="cta-band-title">
      <div className="hp-container">
        <div className="hp-cta-band__inner">
          {contact.title ? (
            <h2
              className="hp-h2 hp-cta-band__title"
              id="cta-band-title"
              dangerouslySetInnerHTML={{
                __html: headingInner(contact.title as HeadingBlockData),
              }}
            />
          ) : null}
          {contact.text ? (
            <p
              className="hp-cta-band__text"
              dangerouslySetInnerHTML={{
                __html: headingInner(contact.text as HeadingBlockData),
              }}
            />
          ) : null}
          <ContactActions
            buttons={contact.buttons as ButtonBlockData[]}
            className="hp-actions hp-cta-band__actions"
          />
        </div>
      </div>
    </section>
  );
}

export default function CtaBand() {
  return (
    <Suspense fallback={null}>
      <Band />
    </Suspense>
  );
}
